import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';

import styles from './RiskTransfer.module.scss';
import FormSummarySection from './components/formSummarySection';
import PrincipalRiskSection from './components/principalRiskSection';
import RiskAssesmentSummaryPage from './components/riskAssesmentSummary';
import RiskManagementSummarySection from './components/riskManagementSummarySection';
import StepperV2, {
  StepperV2Items,
} from '../../components/stepperv2/StepperV2';
import StepperV2Navigation from '../../components/stepperv2/StepperV2Navigation';

const RiskTransfer = () => {
  const formMethods = useForm();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();

  const [formValid, setFormValid] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [stepperItems, setStepperItems] = useState<StepperV2Items[]>([
    {
      number: 11,
      order: 0,
      label: 'Risk Assessment Summary',
      completed: false,
      src: '/icons/form.svg',
      element: <RiskAssesmentSummaryPage validChanged={setFormValid} />,
    },
    {
      number: 12,
      order: 1,
      label: 'Form Summary',
      completed: false,
      src: '/icons/form.svg',
      element: <FormSummarySection validChanged={setFormValid} />,
    },
    {
      number: 13,
      order: 2,
      label: 'Risk Management Summary',
      completed: false,
      src: '/icons/form.svg',
      element: <RiskManagementSummarySection validChanged={setFormValid} />,
    },
    {
      number: 14,
      order: 3,
      label: 'Principal Risk Report',
      completed: false,
      src: '/icons/form.svg',
      element: <PrincipalRiskSection validChanged={setFormValid} />,
    },
  ]);

  useEffect(() => {
    const isReverse = params.get('reverse') != null;
    if (isReverse) {
      setCurrentIndex(stepperItems.length - 1);
      const stepper = stepperItems;
      stepper.forEach((s, ind) => {
        if (ind < stepper.length - 1) {
          s.completed = true;
        }
      });
      setStepperItems(stepper);

      setTimeout(() => {
        params.delete('reverse');
        setParams(params);
      }, 200);
    }
  }, []);

  // #region Methods
  const nextHandler = () => {
    if (!formValid) return;

    if (currentIndex < stepperItems.length - 1) {
      stepperItems[currentIndex].completed = true;
      setCurrentIndex((prev) => ++prev);
    } else {
      navigate('/report');
    }
  };
  const prevHandler = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => {
        let prevIndex = --prev;
        stepperItems[prevIndex].completed = false;

        return prevIndex;
      });
    } else {
      navigate('/');
    }
  };
  // #endregion Methods

  return (
    <FormProvider {...formMethods}>
      <StepperV2 items={stepperItems} currentStepIndex={currentIndex}>
        <div className={styles.sectionContainer}>
          {stepperItems[currentIndex].element}
        </div>
      </StepperV2>

      <StepperV2Navigation
        onPrev={prevHandler}
        onNext={nextHandler}
        nextDisabled={!formValid}
        isLast={currentIndex == stepperItems.length - 1}
      />
    </FormProvider>
  );
};

export default RiskTransfer;
